import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { CreatePlanRequest, MinimalGlobalPlan } from "../../../apis/ersys-data"
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, darken } from "@mui/material"
import { useState } from "react"

interface StorePlanCreationModalProps {
  open: boolean
  plans: MinimalGlobalPlan[]
  onClose: () => void
  onCreate: (req: CreatePlanRequest) => Promise<void>
}

const StorePlanCreationModal: React.FC<StorePlanCreationModalProps> = ({
  open,
  plans,
  onCreate,
  onClose,
}) => {
  const [currentId, setCurrentId] = useState<number>(0)

  const handleCreate = () => {
    onCreate({ globalPlanId: currentId })
  }

  const truncate = (str: string, len: number): string => {
    return str.length > len ? str.substring(0, len - 3) + "..." : str;
  }

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <DialogTitle id="alert-dialog-title">Create Store Plan</DialogTitle>
      <DialogContent>
        <TableContainer sx={{ height: 450, width: 500 }} component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {plans.map((plan) => (
                <TableRow
                  sx={{ '&:last-child td, &:last-child th': { border: 0 }, ...(plan.id === currentId) && { backgroundColor: darken("#FFF", .1) } }}
                  key={plan.id}
                  onClick={() => setCurrentId(plan.id)}>
                  <TableCell>{truncate(plan.name, 75)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={e => handleCreate()} disabled={currentId === 0} autoFocus>
          Ok
        </Button>
        <Button onClick={() => onClose()} autoFocus>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default StorePlanCreationModal
